import { render } from "./SwdRetiredLabel.vue?vue&type=template&id=dadca31e"
import script from "./SwdRetiredLabel.vue?vue&type=script&lang=js"
export * from "./SwdRetiredLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__